import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  getMySupportersSuccess,
  getMySupportersFailure,
  getMySupportersPortionSuccess,
  getMySupportersPortionFailure,
  getSupportersByIdSuccess,
  getSupportersByIdFailure,
  getSupportersByIdPortionSuccess,
  getSupportersByIdPortionFailure,
} from "./actions";
import {
  getMySupportersActionTypes,
  getMySupportersPortionActionTypes,
  getSupportersByIdActionTypes,
  getSupportersByIdPortionActionTypes,
} from "./actionTypes";

const getMySupportersAsync = ({ UsersService, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.getMySupporters(params);
};

function* getMySupporters({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMySupportersAsync, {
      UsersService,
      params,
    });

    yield put(getMySupportersSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMySupportersFailure(error));
  }
}

function* getMySupportersPortion({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMySupportersAsync, {
      UsersService,
      params,
    });

    yield put(getMySupportersPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMySupportersPortionFailure(error));
  }
}

const getSupportersByIdAsync = ({ UsersService, id, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.supportersByUserId(id, params);
};

function* getSupportersById({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getSupportersByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getSupportersByIdSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getSupportersByIdFailure(error));
  }
}

function* getSupportersByIdPortion({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getSupportersByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getSupportersByIdPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getSupportersByIdPortionFailure(error));
  }
}

export function* watchGetMySupporters() {
  yield takeEvery(getMySupportersActionTypes.request, getMySupporters);
}

export function* watchGetMySupportersPortion() {
  yield takeEvery(
    getMySupportersPortionActionTypes.request,
    getMySupportersPortion,
  );
}

export function* watchSupportersById() {
  yield takeEvery(getSupportersByIdActionTypes.request, getSupportersById);
}

export function* watchSupportersByIdPortion() {
  yield takeEvery(
    getSupportersByIdPortionActionTypes.request,
    getSupportersByIdPortion,
  );
}
